/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SimpleStripeUser = {
    stripe_id: string;
    email: string;
    name: string | null;
    auth0_user_id: string;
    billing_type?: SimpleStripeUser.billing_type | null;
};
export namespace SimpleStripeUser {
    export enum billing_type {
        CENTRALIZED = 'centralized',
        DECENTRALIZED = 'decentralized',
    }
}

